import { render, staticRenderFns } from "./PrimarySelect.vue?vue&type=template&id=4e4c1270&scoped=true"
import script from "./PrimarySelect.vue?vue&type=script&lang=js"
export * from "./PrimarySelect.vue?vue&type=script&lang=js"
import style0 from "./PrimarySelect.vue?vue&type=style&index=0&id=4e4c1270&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4c1270",
  null
  
)

export default component.exports